// extracted by mini-css-extract-plugin
module.exports = {"default":"label_default__jD_NF","RENT":"label_RENT__2X4Hv","rent":"label_RENT__2X4Hv","BUY":"label_BUY__1P9e8","buy":"label_BUY__1P9e8"};
    if(module.hot) {
      // 1790670230140
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  